import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden">
      <div className="dark-strip-bg text-white">
        <div className="container-cd py-24 lg:py-32 relative">
          <div className="max-w-3xl">
            <span className="badge-cd !bg-white/10 !text-cyan-300 !border-white/20">Ready When You Are</span>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
              Ready to Secure <br className="hidden md:block" />
              <span className="bg-gradient-to-r from-cyan-300 via-blue-300 to-purple-300 bg-clip-text text-transparent">
                Your Business?
              </span>
            </h2>
            <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
              Let our experts protect your organization from evolving cyber threats.
              From SOC monitoring to awareness training — one partner, end-to-end.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/contact" data-testid="cta-request-consultation" className="btn-accent">
                Request Consultation <ArrowUpRight size={18} />
              </Link>
              <Link to="/contact" data-testid="cta-talk-expert" className="btn-ghost !text-white !border-white/25 hover:!bg-white/10 hover:!text-white">
                Talk to an Expert
              </Link>
              <a href="tel:+919315649601" data-testid="cta-phone-link" className="flex items-center gap-2 text-cyan-300 font-mono-tech tracking-wider text-sm hover:text-white transition-colors">
                <Phone size={16} /> +91 93156 49601
              </a>
              <a href="tel:1930" data-testid="cta-1930-link" className="flex items-center gap-2 text-cyan-200 font-mono-tech tracking-wider text-sm hover:text-white transition-colors">
                <Phone size={16} /> 1930 · Cyber Helpline
              </a>
            </div>
          </div>

          <div className="pointer-events-none absolute -right-10 top-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full bg-cyan-400/10 blur-3xl" />
          <div className="pointer-events-none absolute right-40 bottom-0 w-[280px] h-[280px] rounded-full bg-purple-500/20 blur-3xl" />
        </div>
      </div>
    </section>
  );
}
